import { TripDesign } from './types';
import { parlorScreen } from './parlor-screen';

const designs: Record<string, TripDesign> = {
  'parlor-screen': parlorScreen,
};

export function getDesign(id: string): TripDesign {
  return designs[id] || designs['parlor-screen'];
}

export function getAllDesigns(): TripDesign[] {
  return Object.values(designs);
}
